.ADHWrapper
    padding: 10px 20px
    width: 100%
    display: flex
    justify-content: space-between
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    z-index: 11
    .ADHContainer
        min-width: 0
        display: flex
        flex-direction: column
        padding-right: 10px
        flex-grow: 1
        .ADHName
            font-size: 14px
            font-weight: 700
        .ADHTitle
            font-size: 12px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
    .ADHImage
        width: 0
        height: 40px
        overflow: hidden
        margin-right: 0
        flex-shrink: 0
        border-radius: $globalSettingsRoundingSmall
        transition: width .2s
        transition-timing-function: cubic-bezier(0.42, 0, 0.54, 1.29)
    .ADHImageVisible
        width: 40px
        margin-right: 10px
        img
            width: 40px
            height: 40px
            cursor: pointer !important

